<template>
  <AsideLayout image-path="set-credentials-aside.svg">
    <template v-slot:title>Password requirements</template>
    <template v-slot:list>
      <li>At least 8 characters</li>
      <li>A lowercase letter</li>
      <li>An uppercase letter</li>
      <li>A number</li>
      <li>No parts of username</li>
    </template>
  </AsideLayout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import AsideLayout from "@/modules/aside/AsideLayout.vue";

@Options({
  components: { AsideLayout },
})
export default class SetCredentialsAside extends Vue {}
</script>
